module.exports = __webpack_public_path__ + "img/CTWP__Staff_06.91674969.png";